<template>
  <div class="size-3! rounded-full bg-emerald-500/20 p-0.75">
    <div class="h-full w-full rounded-full bg-emerald-500" />
  </div>
</template>
